import { Connection } from "./Connection.model";

export class TopicConnection extends Connection {
    public clientId!: string
    public clientSecret!: string
    public topicConnectionString!: string
    public serviceBus!: string
    public topicName!: string
}